export const routes = {
    HOME: { path: '/', name: "nav.home" },
    ABOUT: { path: '/what-is-prosperh', name: "nav.about" },
    EXPLORE: { path: '/all-topics', name: "nav.all_topics" },
    MODULE: { path: '/module/:moduleId' },
    UNIT: { path: '/module/:moduleId/unit/:unitId' },
    FAVORITES: { path: '/favorites', name: "common.favorites" },
    LOGIN: { path: '/login/' },
    REGISTER: { path: '/register/' },
    FORGOT_PASSWORD: { path: '/login/forgot-password' },
    PASSWORD_RECOVERY: { path: '/login/recovery' },
    PASSWORD_RESET: { path: '/activate' },
    MY_ACCOUNT: { path: '/account', name: "nav.profile"  },
    CONTACTS: { path: '/contacts', name: "nav.contact_feedback"  },
    DSS: { path: '/workplace-assessment', name: "nav.dss" },
    DSS_FORM: { path: '/workplace-assessment/:formId' },
    FAQS: { path: '/faqs', name: "nav.faqs" },
    PAGE_404: { path: '/404', name: "nav.404" },
    STYLEGUIDE: { path: '/styleguide' },
    TRANSLATIONS: { path: '/translations' },
    TYPEFORMS: { path: '/typeforms' },
    LEGAL: { path: '/legal' }
};
